import { formatFormFieldReport } from '../ProblemsReporter.js';

export const execute = (node, context) => {

  const {
    executionPlatformLabel,
    reporter,
    category
  } = context;

  if ([ 'checkbox', 'checklist', 'taglist' ].includes(node.type) && node.validate && node.validate.required)
  {
    const errorMessage = `Required validation is not supported by ${executionPlatformLabel} for ${node.type} elements`;
    reporter.report(formatFormFieldReport(node, errorMessage, category));
  }

  return true;
};
